<template>
  <base-modal
    v-if="showModal"
    @close="showModal = false"
  >
    <template #heading>
      Please select your industry type
    </template>

    <div class="desc">
      Use the list below to select the category that most represents your business. <br>
      We will use this data to help generate better SEO recommendations for your website.
    </div>

    <div class="wrapper">
      <custom-select
        v-model="industry"
        :options="industries"
        placeholder="Please select your websites industry"
        :searchable="true"
        :validation-errors="errors?.industry"
      />

      <primary-button
        size="md"
        @click="save"
      >
        {{ saving ? 'Saving' : 'Save' }}
        <i
          v-if="saving"
          class="fas fa-spin fa-spinner"
        />
      </primary-button>
    </div>
  </base-modal>
</template>

<script>
import BaseModal from "../../../../js/components/global/modals/BaseModal";
import axios from "axios";
import {mapState} from "vuex";
import PrimaryButton from "../../../../js/components/global/buttons/PrimaryButton";
import CustomSelect from "../../../reports/components/global/forms/CustomSelect";
import SweetToast from "../../../../js/SweetToast";

export default {
  components: {
    CustomSelect,
    PrimaryButton,
    BaseModal,
  },
  data() {
    return {
      industry: null,
      industries: null,
      showModal: false,
      errors: [],
      saving: false,
    }
  },
  computed: {
    ...mapState('dashboard', [
      'activeWebsite',
      'uuid',
    ]),
  },
  watch: {
    activeWebsite: {
      handler(website) {
        if (website && !website.industry_gcid) {
          this.requestUserInput();
        }
      }
    },
    industry() {
      this.errors = [];
    }
  },
  methods: {
    requestUserInput() {
      axios.get('/ajax/dashboard/get-industries')
        .then(({ data }) => {
          this.industries = data.industries;
          this.showModal = true;
        });
    },
    save() {
      this.saving = true;
      const { industry, uuid } = this;
      axios.post('/ajax/dashboard/save-industry', {
          industry,
          uuid,
        })
        .then(() => {
          this.showModal = false;
          SweetToast.fire({
            icon: 'success',
            title: 'Industry saved successfully',
          })
        })
        .catch(({response}) => {
          const { status, data } = response;

          if (status === 422) {
            const { errors } = data;
            this.errors = errors;
            return;
          }

          const { error } = data;
          SweetToast.fire({
            icon: 'error',
            title: error ?? 'Something went wrong',
          });
        })
        .finally(() => {
          this.saving = false;
        });
    }
  },
}
</script>

<style lang="scss" scoped>
  :deep(.modal_window) {
    overflow: unset!important;
    max-width: 620px;
  }

  .wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    z-index: 100;

    :deep(.custom_input) {
        .multiselect svg {
          z-index: 1;
        }

    }

    .desc {
      font-family: var(--primary-font);
      color: var(--secondary-font-color);
      font-weight: 400;
      margin-bottom: 1rem;
      text-align: center;
    }
  }

</style>
